export const getFocusBoxShadow = (theme) => `0 0 0 1px ${theme.colors.white}, 0 0 0 3px ${theme.colors.sea}`;
